<script lang="tsx">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'JtDetailDialog',
})
</script>
<!--
 * @Descripttion: 
 * @version: 详情弹窗json配置组件
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-01-19 10:46:30
-->
<template>
  <Modal
    :visible="visible"
    wrapClassName="globalModal"
    v-bind="$attrs"
    destroyOnClose
    :title="title || $lang('详情')"
    @cancel="cancel"
    :width="width || '40%'"
  >
    <Form layout="vertical">
      <div v-for="(item, index) in columns" :key="index">
        <FormGroup :title="item.groupTitle" v-if="item.group" />
        <Row :gutter="24" v-if="!item.slot">
          <!-- 默认为6 表示默认一行4列,可根据需求自定义传入 -->
          <Col :span="_.span || 6" v-for="_ in item.childs" v-show="_.show !== false">
            <FormItem :label="$lang(_.label)">
              <!-- 渲染图片类型  -->
              <div class="photo-list" v-if="_.type === 'image'">
                <Image v-for="v in _.photoList" :src="v.path" />
              </div>

              <!-- 渲染文本类型 -->
              <div v-else>
                <!-- customRender自定义渲染内容 -->
                <div class="rendSlot" v-if="_.customRender">{{ customRender(_.customRender) }}</div>
                <div v-else>
                  <!-- formatter格式化内容 -->
                  <div v-if="_.formatter">{{ formatter(_, _.prop, _.formatter) }}</div>
                  <div v-else>{{ formState[_.prop] || '--' }}</div>
                </div>
              </div>
            </FormItem>
          </Col>
        </Row>
        <slot v-if="item.slot"> </slot>
      </div>
    </Form>

    <template #footer>
      <Button type="primary" ghost @click="cancel">{{ $lang('关闭') }}</Button>
    </template>
  </Modal>
</template>
<script lang="tsx" setup name="JtDetailDialog">
  import { render, toRefs, reactive, watch } from 'vue'
  import { Modal, Row, Col, Form, FormItem, Button, Image } from 'ant-design-vue'
  import { isSuccess } from '@/utils'

  interface IColumunProp {
    label: string
    prop: string
    span?: number
    show?: boolean
    type?: string
    photoList?: Array<{ path: string }>
    formatter?: void
    customRender?: void
  }
  interface IColumuns {
    group: boolean
    groupTitle: string
    childs: Array<IColumunProp>
    slot?: boolean
  }
  interface Props {
    visible: boolean
    title: string
    width: string
    columns: Array<IColumuns>
    params: object
    ajaxUrl: Function
  }
  const props = defineProps<Props>()
  const emit = defineEmits(['update:visible'])
  const { visible, title, columns, params, ajaxUrl } = toRefs(props)
  const formState = reactive({})

  /**
   * 获取详情
   */
  const getDetail = async () => {
    const res = await ajaxUrl.value(params.value)
    if (!isSuccess(res)) return
    Object.assign(formState, res.data)
  }

  /**
   * formatter格式化方法
   * @param record 当前列数据
   * @param value 值
   * @param cb  回调函数
   */
  const formatter = (record: any, value: string, cb: Function) => {
    if (typeof cb === 'function') {
      return cb(formState, formState[value])
    }
  }

  /**
   * customRender 支持传入DOM结构元素渲染
   * @param cb 自定义渲染回调函数传回的tsx结构元素内容
   */
  const customRender = (cb: Function, value: string) => {
    const element = document.getElementsByClassName('rendSlot')[0] as HTMLElement
    if (element && typeof cb === 'function') {
      render(cb(formState, formState[value]), element)
    }
  }

  /**
   * 通知关闭弹窗
   */
  const cancel = () => {
    emit('update:visible', false)
  }

  watch(
    () => props.visible,
    () => {
      if (props.visible) {
        getDetail()
      }
    }
  )
</script>
<style lang="less" scoped>
  :deep(.ant-form-item-label) {
    padding-bottom: 0;
  }

  .photo-list {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    :deep(.ant-image) {
      width: 30%;
      margin-top: 10px;
      margin-right: 5px;
    }

    :deep(.ant-image-img) {
      width: 100%;
      height: 50px;
      border-radius: 6px;
    }
  }
</style>
